import React from 'react';
import { i18n } from 'utils/i18n';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';

import EditVehicleModalContent from './EditVehicleModalContent';

const EditVehicleModal = () => (
  <Modal modalKey={MODAL.EDIT_VEHICLE} header={i18n('edit_vehicle_modal_header')} theme={MODAL_THEMES.WHITE}>
    {({ linkTo }) => <EditVehicleModalContent linkTo={linkTo} />}
  </Modal>
);

export default EditVehicleModal;
